export class Numeric {
  private readonly amount: number;

  constructor(amount: string | number | undefined | null) {
    this.amount = parseInt((amount || '0').toString(), 10) || 0;
  }

  format() {
    return this.amount;
  }
}
